// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAghst } from "../../../icons/mono/build/icon-aghst.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AghstIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAghst.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AghstIcon.displayName = 'AghstIcon';
}

export default AghstIcon;